/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaListFullResponse } from '../../models/media-list-full-response';

export interface MediaControllerListFilesAndFolders$Params {
  prefix?: string;
  query?: string;
  recursive?: string;
}

export function mediaControllerListFilesAndFolders(http: HttpClient, rootUrl: string, params?: MediaControllerListFilesAndFolders$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaListFullResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerListFilesAndFolders.PATH, 'get');
  if (params) {
    rb.query('prefix', params.prefix, {});
    rb.query('query', params.query, {});
    rb.query('recursive', params.recursive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaListFullResponse;
      }>;
    })
  );
}

mediaControllerListFilesAndFolders.PATH = '/file-manager/file';
